import { Component, Input, Output, ViewChild, EventEmitter } from '@angular/core';
import { StepsService } from '../../../services/steps.service';
import { IInitializePasswordRequest } from '../../../classes/initialize-password';
import { AppSettings } from '../../../app.settings';
import { ICardLoginResponse } from '../../../classes/existing-onboarding-customer/responses';
import { CardVerificationComponent } from './card-verification.component';

@Component({
    selector: 'restore-password-with-card-container',
    template: require('./restore-password-with-card-container.component.html'),
})
export class RestorePasswordWithCardContainerComponent {
    @Input() initRequest: IInitializePasswordRequest;
    @Input() public isLoginBigModalEnabled: boolean = AppSettings.isLoginBigModalEnabled;
    @Input() public username: string;
    @Output() isCardValid = new EventEmitter<boolean>();
    @Output() cardVerified = new EventEmitter<ICardLoginResponse>();
    @ViewChild(CardVerificationComponent, { static: false }) cardVerificationComponent: CardVerificationComponent;

    public isRebrading = AppSettings.isRebrading;

    constructor(public stepsService: StepsService) { }

    public checkStep0(): boolean {
        return this.stepsService.getCurrentStep === 0;
    }

    public checkStep1(): boolean {
        return this.stepsService.getCurrentStep === 1;
    }

    public checkStep2(): boolean {
        return this.stepsService.getCurrentStep === 2;
    }

    public checkStep3(): boolean {
        return this.stepsService.getCurrentStep === 3;
    }

    public onCardValid(isValid: boolean): void {
        this.isCardValid.emit(isValid);
    }

    public validateCard(): void {
        // Find the card verification component and trigger validation
        if (this.cardVerificationComponent) {
            this.cardVerificationComponent.continue();
        }
    }

    // Add ViewChild to get reference to the card verification component

    public onCardVerified(response: ICardLoginResponse): void {
        // Emit the card verification event up to the parent component
        this.cardVerified.emit(response);
    }
}
